<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col col-4">
        <strong>OFFICE</strong>
        <app-office [office]="office" [displayPhoneAndFax]="false" [allowCopyOfficeName]="true" />
      </div>
      <div class="col">
        <strong>OFFICE STATUS</strong>
        @if (office.status) {
          <div>{{ keyedStatusOptions[office.status]?.display }}</div>
        }
        @if (!office.status) {
          <div><app-blank-value-dash /></div>
        }
      </div>
      <div class="col">
        <strong>PHONE</strong>
        <div>
          <app-phone-number [number]="office.phone" [dialpad]="true" />
        </div>
      </div>
      <div class="col">
        <strong>FAX</strong>
        <div>
          <app-office-fax [office]="office" [allowLinkToOffice]="false" />
        </div>
      </div>
      <div class="col">
        <strong>COMM METHOD</strong>
        @if (office.communicationMethod) {
          <div>{{ office.communicationMethod }}</div>
        }
        @if (!office.communicationMethod) {
          <div><app-blank-value-dash /></div>
        }
      </div>
      <div class="col">
        <strong>HIE</strong>
        @if (office.hieConsultNotesCollected) {
          <div>TRUE</div>
        }
        @if (!office.hieConsultNotesCollected) {
          <div><app-blank-value-dash /></div>
        }
      </div>
      <div class="col text-end">
        <a href="javascript:;" (click)="onEdit($event)"><fa-icon [icon]="['fas', 'pen']" /></a>
      </div>
    </div>
    <div class="row">
      <div class="col col-4">
        <strong>WEBSITE</strong>
        @if (office.website) {
          <div><a [href]="office.website" target="_blank">{{ office.website }}</a></div>
        }
        @if (!office.website) {
          <div><app-blank-value-dash /></div>
        }
      </div>
      <div class="col">
        <strong>EMPLOYED STATUS</strong>
        @if (office.employedBy && office.employedBy.length > 0) {
          <div>{{ office.employedBy | joinList }}</div>
        }
        @if (!office.employedBy || office.employedBy.length === 0) {
          <div><app-blank-value-dash /></div>
        }
      </div>
    </div>
  </div>
</div>
